import { Box, CircularProgress, Fade, Grow, Stack, Typography, Zoom } from "@mui/material";
import { ReactNode, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import Footer from "../../components/Footer/Footer";
import Loader from "../../components/Loader";
import PopUp from "../../components/PopUp/PopUp";
import { CUSTOMER } from "../../config/constants";
import { userIsAuthenticated } from "../../stateManagement/helpers";
import { IAuthState, IUser, resetLoggedOut, tryConfirmLogin } from "../../stateManagement/reducers/authReducer";
import { IOrder, IOrdersState, setActiveMembership, tryFetchActiveMembership } from "../../stateManagement/reducers/ordersReducer";
import { IRentalItem, setFavouriteRentalItems } from "../../stateManagement/reducers/rentalItemsReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import Background from "./Background";
import Header from "./components/Header";
import IndexHeader from "../../components/Headers/IndexHeader";
import IndexNavbar from "../../components/Navbars/IndexNavbar";

const GeneralLayout = () => {


    const dispatch = useDispatch<any>();
    const { user, authToken, confirmingLogin, realRole, loggedOut } = useSelector<IRootReducerT, IAuthState>(state => state.auth);
    const { fetchActiveMembershipErr, fetchingActiveMembership, activeMembership } = useSelector<IRootReducerT, IOrdersState>(state => state.orders);
    const location = useLocation();
    const [favItems, setFavItems] = useState<IRentalItem[]>([]);

    let layout: ReactNode | null = null;

    const [show, setShow] = useState(false);

    const [isInitRender, setIsInitRender] = useState(true);
    useEffect(() => {
        if (isInitRender) {
            setIsInitRender(false);
            return;
        }

        setShow(false);
    }, [isInitRender, location.pathname]);

    useEffect(() => {
        if (!show) {
            setTimeout(() => {
                setShow(true);
            }, 100);
        }
    }, [show]);

    useEffect(() => {

        if (user?.role && realRole && (user.role.name !== realRole.name)) {
            return;
        }

        if (user && (user?.role?.name === CUSTOMER)) {

            dispatch(tryFetchActiveMembership({ authToken: authToken ?? '' }));

            if (userIsAuthenticated(user as IUser)) {
            }
        }
    }, [user]);


    useEffect(() => {
        if (user?.role && realRole && (user.role.name !== realRole.name)) {
            return;
        }

        dispatch(tryConfirmLogin({ authToken: authToken ?? "", setFavouriteRentalItems: setFavItems }));
    }, []);

    useEffect(() => {
        if (favItems.length > 0) {
            dispatch(setFavouriteRentalItems(favItems));
        }
    }, [favItems]);

    const [isInitRender120, setIsInitRender120] = useState(true);
    useEffect(() => {
        if (isInitRender120) {
            setIsInitRender120(false);
            dispatch(resetLoggedOut({ authToken: authToken ?? '' }));
            return;
        }
    }, [loggedOut]);

    return (
        <>
            <Box
                sx={{
                    position: "fixed",
                    left: 0,
                    top: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: "warning.focus",
                    background: "linear-gradient(to right, #cd7d00 0 %, #194951 100 %)",
                    zIndex: '-1',
                    overflowX: 'hidden !important',
                    '& .navbar-collapse': {
                        height: '100% !important'
                    }
                }}
            />
            {
                show

                &&

                <Outlet />
            }
        </>
    );
}

export default GeneralLayout;